import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Gift, Radio, MessageCircle, Sparkles, ExternalLink } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { SOCIALS } from "../mock";

const highlights = [
  {
    Icon: Radio,
    title: "Live Stream Drops",
    desc: "I regularly hand out exclusive giveaways live during my streams. Tune in and you could win just for being there.",
  },
  {
    Icon: MessageCircle,
    title: "Discord Exclusives",
    desc: "The Broer Discord gets its own giveaways, drops and rewards you won't find anywhere else - only for the community.",
  },
  {
    Icon: Sparkles,
    title: "Surprise Rewards",
    desc: "From balance boosts to bonus hunts and random prizes, there's always something going on for active members.",
  },
];

const PerksPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#2f2753]">
      <Header />
      <main className="pt-28">
        <section className="px-5 pt-10 pb-6">
          <div className="max-w-4xl mx-auto">
            <Link to="/" className="inline-flex items-center gap-2 text-[#b7b0d6] hover:text-white font-semibold transition-colors mb-8">
              <ArrowLeft size={18} /> Back to home
            </Link>
            <div className="text-center">
              <div className="inline-flex items-center gap-2 rounded-full bg-[#edbb23]/15 border border-[#edbb23]/40 px-4 py-1.5 mb-5">
                <Gift size={15} className="text-[#edbb23]" />
                <span className="text-xs font-extrabold tracking-widest text-[#edbb23]">EXCLUSIVE PERKS</span>
              </div>
              <h1 className="text-4xl md:text-6xl font-black text-white tracking-tight">Exclusive Giveaways</h1>
              <p className="mt-5 text-[#b7b0d6] max-w-2xl mx-auto leading-relaxed">
                I run <span className="text-white font-semibold">exclusive giveaways</span> all the time - both live during
                my streams and inside the Broer Discord. Join the community, stay active and grab your share of free drops,
                rewards and prizes.
              </p>
            </div>
          </div>
        </section>

        <section className="px-5 py-14">
          <div className="max-w-5xl mx-auto grid md:grid-cols-3 gap-6">
            {highlights.map((h) => (
              <div key={h.title} className="rounded-2xl bg-[#342b60] border border-[#473c7d] p-7 text-center transition-all duration-300 hover:-translate-y-1 hover:border-[#edbb23]/50">
                <div className="mx-auto mb-5 w-14 h-14 rounded-xl bg-[#edbb23] flex items-center justify-center text-[#251e44]">
                  <h.Icon size={26} />
                </div>
                <h3 className="text-xl font-extrabold text-white mb-2">{h.title}</h3>
                <p className="text-sm text-[#b7b0d6] leading-relaxed">{h.desc}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-12">
            <a
              href={SOCIALS.kick}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#53fc18] hover:bg-[#63ff2e] text-[#0e1b0a] font-extrabold rounded-xl px-8 h-14 transition-colors"
            >
              <Radio size={18} /> WATCH ON KICK <ExternalLink size={16} />
            </a>
            <a
              href={SOCIALS.discord}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#5865F2] hover:bg-[#6b77f5] text-white font-extrabold rounded-xl px-8 h-14 transition-colors"
            >
              <img src="/assets/discord-white.png" alt="" className="w-5 h-5 object-contain" /> JOIN DISCORD
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PerksPage;
